/**
 * 业务监测点国际化
 * date：2022 03 24
 */
export default {
  carrier: {
    incubator: '保温箱',
    fridge: '冰箱',
    car: '车辆',
    refrigeratory: '冷库',
    // 后续有添加 监测点 则 需要手动在这里添加国际化
    run: '运行',
    backup: '备用',
    retirement: '报废',
    repaired: '维修中',
    defrost: '除霜',
    warehouse: '仓库',
    store: '店铺',
    other: '其他',
    1: '保温箱',
    2: '冰箱',
    3: '车辆',
    4: '冷库',
    5: '仓库',
    6: '店铺',
    7: '其他',

    operate_failed: '操作失败',
    operate_ok: '操作成功'
  }
}
